

import React from 'react';
import Button from './Button';

const ConfirmModal = ({ 
    title, 
    subText, 
    confirmMessage, 
    content,
    cancelText = "Cancel", 
    submitText = "Submit", 
    disableCancel = false,
    disableSubmit = false,
    onCancel, 
    onSubmit 
}) => {
    const isMultiWordSubmitText = typeof submitText === 'string' && submitText.trim().split(/\s+/).length >= 2;

    return (
        <div
            className="overlayHolder bg-black/30 dark:bg-black/60 fixed inset-0 flex justify-center top-0 z-[999]"
            data-testid="confirm-modal"
        >
            <div className="modalHlder bg-ivory dark:bg-darkThemeModalBg dark:shadow-darkThemeDropdownMenuShadow rounded-2xl border border-black/10 w-full mx-5 sm:w-[400px] sm:mx-auto  my-auto p-4 lg:p-6 overflow-auto">
                <div>
                    <div className="modalContent">
                        <div className="flex flex-col gap-1">
                            <h2 className="modalTitle text-dark-grey dark:text-white text-lg leading-5 lg:text-xl lg:leading-6 font-semibold tracking-[0.03px]">{title}</h2>
                            {subText && (
                            <p className="text-dark-grey dark:text-white text-xs leading-4 tracking-[0.021px] font-normal w-full lg:w-11/12">{subText}</p>
                            )}
                        </div>
                        {confirmMessage && (
                        <div className="modalMessageHolder mt-4 sm:mt-6">
                            <div className="text-dark-grey dark:text-white text-sm leading-4 lg:text-base lg:leading-6 font-normal tracking-[-0.408px]">{confirmMessage}</div>
                        </div>
                        )}
                        {content && (
                        <div className="mt-4 sm:mt-6">
                            {content}
                        </div>
                        )}
                        <div className=" mt-6 sm:mt-10 actionsHolder">
                            <div className="flex items-center flex-wrap sm:flex-nowrap gap-4 lg:gap-6 justify-center sm:justify-end">
                                <Button
                                    onClick={onSubmit}
                                    disabled={disableSubmit}
                                    data-testid="confirm-modal-submit"
                                    className={`flex justify-center items-center ${isMultiWordSubmitText ? 'basis-48' : 'basis-24'} shrink bg-theme px-5 py-3 text-white text-base font-semibold leading-5 tracking-[-0.32px] rounded-md h-10 transition-all duration-300 ease-in-out ${disableSubmit ? 'cursor-not-allowed opacity-60' : 'cursor-pointer hover:bg-theme/80'}`}
                                >
                                    {submitText} 
                                </Button>
                                <Button
                                    onClick={onCancel}
                                    disabled={disableCancel}
                                    data-testid="confirm-modal-cancel"
                                    className={`flex justify-center items-center basis-24 shrink border border-theme px-5 py-3 text-theme text-base font-semibold leading-5 tracking-[-0.32px] rounded-md h-10 transition-all duration-300 ease-in-out ${disableCancel ? 'cursor-not-allowed opacity-60' : 'cursor-pointer hover:bg-theme hover:text-white'}`}
                                >
                                    {cancelText}
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConfirmModal;
